import { UntypedFormGroup, ValidatorFn } from '@angular/forms';

export function matchingPasswords(
  passwordKey: string,
  passwordConfirmationKey: string,
): ValidatorFn {
  return (group: UntypedFormGroup) => {
    const password = group.controls[passwordKey];
    const passwordConfirmation = group.controls[passwordConfirmationKey];
    const isMismatch =
      password.value !== passwordConfirmation.value && passwordConfirmation.value && password.value;

    return isMismatch ? { mismatchedPasswords: true } : null;
  };
}
